import { UseParamsReturnType } from 'core/hooks/useParams'
import { useMemo } from 'react'
import useScopedPreferences from 'core/session/useScopedPreferences'
import { generateObjMemoizer } from 'utils/misc'

export type GlobalParams = {
  clusterId: string[]
  namespace: string[]
}

export default function useGlobalParams<P>(
  useParamsHook: (defaultParams?: P) => UseParamsReturnType<P>,
  defaultParams: P,
): UseParamsReturnType<P> & {
  allParams: P & GlobalParams
  globalParams: GlobalParams
  updateGlobalParams: (globalParams: GlobalParams) => void
} {
  const memoizedParams = useMemo(() => generateObjMemoizer<P & GlobalParams>(), [])
  const prefParams = useParamsHook(defaultParams)
  const { params } = prefParams
  const { prefs: globalParams, updatePrefs: updateGlobalParams } = <
    { prefs: GlobalParams; updatePrefs: (prefs: GlobalParams) => void }
  >useScopedPreferences<GlobalParams>('globalParams')
  const allParams = memoizedParams({ ...params, ...globalParams })
  return { ...prefParams, allParams, globalParams, updateGlobalParams }
}
